import React from 'react';
import { Row, Col } from 'reactstrap';

export const ProductTypesPop = (props) => (
    <Row>
        <Row className="w-100 header-blue ml-3 mr-3">
            <Col xs="7">Product Name</Col>
            <Col xs="7">What will you get</Col>
            <Col xs="6">How long will it take</Col>
            <Col xs="4">Charges</Col>
        </Row>
        {
            props.productTypes.map(p => {
                return (
                    <Row key={p.id} className="modal-report-type-item w-100 ml-3 mr-3">
                        <Col xs="7">{p.productName}</Col>
                        <Col xs="7">{p.description}</Col>
                        <Col xs="6">{p.turnAroundTime} Days</Col>
                        <Col xs="4">{p.priceMax}</Col>
                    </Row>
                )
            })
        }
    </Row>
)